import script from "./UsosSolo.vue?vue&type=script&setup=true&lang=js"
export * from "./UsosSolo.vue?vue&type=script&setup=true&lang=js"

import "./UsosSolo.vue?vue&type=style&index=0&id=b3ea1f8e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3ea1f8e"]])

export default __exports__